import React from "react";

export default function TeamIconRound() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <g>
        <rect width="24" height="24" fill="#565656" rx="12"></rect>
        <path
          fill="#fff"
          d="M18.032 16.378a6.511 6.511 0 00-1.403-2.08 6.54 6.54 0 00-2.08-1.403l-.021-.01a4.317 4.317 0 10-6.846-3.5c0 1.441.705 2.717 1.79 3.503l-.021.008c-.78.33-1.48.801-2.081 1.404a6.539 6.539 0 00-1.917 4.485.14.14 0 00.14.142h1.044a.14.14 0 00.14-.136 5.19 5.19 0 011.528-3.556 5.19 5.19 0 013.694-1.53 5.19 5.19 0 013.695 1.53 5.19 5.19 0 011.529 3.556.138.138 0 00.139.136h1.045a.14.14 0 00.139-.142 6.487 6.487 0 00-.514-2.407zM12 12.381c-.799 0-1.55-.312-2.117-.878a2.975 2.975 0 01-.877-2.117c0-.799.312-1.551.877-2.117A2.975 2.975 0 0112 6.392c.8 0 1.552.311 2.118.877.565.566.877 1.318.877 2.117 0 .8-.312 1.552-.877 2.117a2.975 2.975 0 01-2.118.878z"
        ></path>
      </g>
    </svg>
  );
}
